import React from 'react';
import { apiUrl } from './config';

function Login() {
  const loginHref = apiUrl('/auth/login');

  return (
    <a className="button spotify-btn" href={loginHref}>
      Login with Spotify
    </a>
  );
}

export default Login;
